import { immerable } from "immer";
import Segment from "@/models/interfaces/segment.ts";

class UserDefinedContent {
    [immerable] = true;

    segment: Segment | undefined;

    scale: number | undefined;

    readonly default: boolean = false; // Attribut qu'un lecture pour raccord avec celui de KnownScaleContent

    static fromJSON(data: Record<string, unknown>) {
        const content = new UserDefinedContent();
        content.segment = (data.segment || data.Segment) as Segment ?? { start: { x: 0, y: 0 }, end: { x: 0, y: 0 } };
        content.scale = (data.scale || data.Scale) as number ?? 1;
        return content;
    }

    clone() {
        const content = new UserDefinedContent();
        content.segment = this.segment;
        content.scale = this.scale;
        return content;
    }
}

export default UserDefinedContent;